import { createFeatureSelector, createSelector } from "@ngrx/store";

import {
    BackInStockState,
    BackInStockStatus,
} from "../models/back-in-stock.state";
import { BACK_IN_STOCK_FEATURE_KEY } from "../reducers/back-in-stock.reducer";

export const selectBackInStockState = createFeatureSelector<BackInStockState>(
    BACK_IN_STOCK_FEATURE_KEY,
);

export const selectBackInStockLoading = createSelector(
    selectBackInStockState,
    (backInStockState: BackInStockState) =>
        backInStockState.status === BackInStockStatus.Loading,
);

export const selectBackInStockCustomerType = createSelector(
    selectBackInStockState,
    (backInStockState: BackInStockState) => backInStockState.customerType,
);
